import {getEnv} from '@/config/environment';
import getCookieValue from './getCookieValue';

export default function getLtid() {
  const cookieName = getEnv().MODE === 'staging' ? 'stg__lt_id' : 'lt_id';
  return getCookieValue(cookieName);
}
